<template>
	<div
		v-bind="$attrs"
		:class="[
			{
				container: !fluid,
				'container-fluid': fluid
			}
		]"
	>
		<div v-if="narrow" class="row justify-content-center">
			<div class="col-lg-10 col-xl-8">
				<slot />
			</div>
		</div>
		<slot v-else />
	</div>
</template>

<script>
export default {
	name: 'Container',
	inheritAttrs: false,
	props: {
		fluid: {
			type: Boolean,
			default: false
		},
		narrow: {
			type: Boolean,
			default: false
		}
	}
}
</script>
